import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getCurrentUser } from "../utils/auth";

const SubscriptionRoute = ({ children }) => {
  const location = useLocation();
  const [state, setState] = useState({ loading: true, allowed: false });

  useEffect(() => {
    let cancelled = false;

    const verifySubscription = async () => {
      const params = new URLSearchParams(location.search);
      const authToken = params.get("authToken");

      if (authToken) {
        localStorage.setItem("accessToken", authToken);
      }

      if (!localStorage.getItem("accessToken")) {
        localStorage.removeItem("isSubscribed");
        localStorage.removeItem("isLoggedIn");
        if (!cancelled) setState({ loading: false, allowed: false });
        return;
      }

      const result = await getCurrentUser();
      const active = result.success && result.isSubscribed;

      localStorage.setItem("isSubscribed", active ? "true" : "false");
      localStorage.setItem("isLoggedIn", active ? "true" : "false");

      if (!active) {
        localStorage.removeItem("accessToken");
      }

      if (!cancelled) setState({ loading: false, allowed: active });
    };

    verifySubscription();

    return () => {
      cancelled = true;
    };
  }, [location.search]);

  if (state.loading) {
    return (
      <div className="min-h-screen bg-[#181820] text-white flex items-center justify-center">
        Checking subscription...
      </div>
    );
  }

  return state.allowed ? children : <Navigate to="/signin" replace />;
};

export default SubscriptionRoute;
